var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUsersV2(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.5003 12.2507C10.5003 11.013 10.0087 9.82599 9.13349 8.95082C8.25832 8.07565 7.07134 7.58398 5.83366 7.58398C4.59598 7.58398 3.409 8.07565 2.53383 8.95082C1.65866 9.82599 1.16699 11.013 1.16699 12.2507",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.83366 7.58333C7.44449 7.58333 8.75033 6.2775 8.75033 4.66667C8.75033 3.05584 7.44449 1.75 5.83366 1.75C4.22283 1.75 2.91699 3.05584 2.91699 4.66667C2.91699 6.2775 4.22283 7.58333 5.83366 7.58333Z",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.8334 11.6665C12.8334 9.7007 11.6667 7.87487 10.5 6.99987C10.8835 6.71215 11.1902 6.33434 11.3929 5.89986C11.5956 5.46538 11.688 4.98764 11.6621 4.50892C11.6361 4.0302 11.4925 3.56525 11.2441 3.15524C10.9956 2.74522 10.6499 2.40277 10.2375 2.1582",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUsersV2);
export default __webpack_public_path__ + "static/media/usersV2.7660b45b4ba6c6bd22e5f145e92e212b.svg";
export { ForwardRef as ReactComponent };